import { render, staticRenderFns } from "./EvidenceImage.vue?vue&type=template&id=1a182586&scoped=true&"
import script from "./EvidenceImage.vue?vue&type=script&lang=js&"
export * from "./EvidenceImage.vue?vue&type=script&lang=js&"
import style0 from "./EvidenceImage.vue?vue&type=style&index=0&id=1a182586&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a182586",
  null
  
)

export default component.exports